import * as React from "react";

import {
  CalculateTimeModal,
  WhatIsIncludedModal,
  IroningServiceModal,
  InteriorWindowsServiceModal,
} from "./modals";

export const BookingModals = (): React.ReactElement => (
  <React.Fragment>
    <CalculateTimeModal />
    <WhatIsIncludedModal />
    <IroningServiceModal />
    <InteriorWindowsServiceModal />
  </React.Fragment>
);
